module.exports = __webpack_public_path__ + "static/media/David Benjamin.4aa432df.png";